import React, { useState } from "react";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import Button from "../../common/button/button";
import Row from "../../common/layout/row";
import ContentCardHeader from "../../common/template/contentCardHeader";
import Select from "../../common/form/select";
import { LabelSelectUcIconeGestor } from "../../common/form/LabelSelectUcIconeGestor";
import Grid from "../../common/layout/grid";
import { ModalFiltrosFaturasClienteEnergia } from "./ModalFiltrosFaturasClienteEnergia";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getListaFaturasAdm, setFiltro } from "../faturaActions";

function FiltrosFaturasClienteEnergiaComponent(props) {
    const [modalFiltrosAberto, setModalFiltrosAberto] = useState(false);

    return (
        <>
            <ModalFiltrosFaturasClienteEnergia visible={modalFiltrosAberto} handleClose={() => setModalFiltrosAberto(false)} {...props} />
            <ContentCardHeader>
                <Row style={{ paddingBlock: 15 }}>
                    {!props.usuarioLogadoAcessoCliente ? (
                        <Select
                            readOnly={props.aguardando || props.filtro.id_empenho}
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 12 5 5"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_cliente: value,
                                    id_empenho: null,
                                    unidades_consumidoras: [],
                                });
                            }}
                        />
                    ) : null}
                    <Select
                        readOnly={props.aguardando || props.filtro.id_empenho}
                        name="ano"
                        options={Array.from({ length: 20 }, (v, i) => ({
                            id: new Date().getFullYear() - 5 + i,
                            valor: new Date().getFullYear() - 5 + i,
                        }))}
                        label="Ano"
                        cols="12 6 2 2"
                        placeholder="Selecione o ano"
                        value={props.filtro.ano}
                        isClearable={false}
                        onChange={(value) => {
                            props.setFiltro({
                                ...props.filtro,
                                ano: value,
                            });
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="mes"
                        options={props.listaMeses}
                        label="Mês"
                        cols="12 6 2 2"
                        placeholder="Selecione o mês"
                        value={props.filtro.mes}
                        onChange={(value) => {
                            props.setFiltro({
                                ...props.filtro,
                                mes: value,
                            });
                        }}
                    />

                    {!(props.usuarioLogadoAcessoCliente && props.isMobile) && props.usuarioLogadoAcessoCliente ? (
                        <>
                            <Select
                                readOnly={props.aguardando}
                                name="id_grupo_faturamento"
                                options={props.listaGrupoFaturamento}
                                label="Tipo de Faturamento"
                                cols="12 12 3 3"
                                placeholder="Selecione o tipo de faturamento"
                                value={props.filtro.id_grupo_faturamento}
                                onChange={(id_grupo_faturamento) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_grupo_faturamento,
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                options={[
                                    { id: 1, valor: "Todas" },
                                    { id: 2, valor: "Download Realizado" },
                                    { id: 3, valor: "Download Pendente" },
                                ]}
                                label="Situação do Download"
                                cols="12 12 2 2"
                                placeholder="Selecione a situação do download"
                                value={props.filtroState.situacaoDownload}
                                isClearable={false}
                                isSearchable={false}
                                onChange={(value) => {
                                    props.setState({
                                        ...props.filtroState,
                                        situacaoDownload: value,
                                    });
                                }}
                            />
                        </>
                    ) : null}
                    {props.exibirFiltroEmpenho ? (
                        <Select
                            readOnly={props.aguardando}
                            options={props.listaEmpenho.map((emp) => ({ id: emp.id, valor: emp.numero }))}
                            label="Nº do Empenho"
                            cols="12 12 3 3"
                            placeholder="Selecione algum empenho do ano filtrado"
                            value={props.filtro.id_empenho}
                            onChange={(value) => {
                                const empenhoSelecionado = props.listaEmpenho.find((emp) => emp.id == value);
                                const listaUcsEmpenho = empenhoSelecionado
                                    ? empenhoSelecionado.unidades_consumidoras.map((uc) => ({
                                          value: uc.id,
                                          label: uc.numero + " - " + uc.nome,
                                      }))
                                    : [];
                                props.setFiltro({
                                    ...props.filtro,
                                    id_empenho: empenhoSelecionado ? value : null,
                                    ano: new Date().getFullYear(),
                                    unidades_consumidoras: [...listaUcsEmpenho],
                                });
                            }}
                        />
                    ) : (
                        !(props.usuarioLogadoAcessoCliente && props.isMobile) && (
                            <Grid cols="12 12 3 3">
                                <Row style={{ paddingLeft: 12, paddingBottom: 12 }}>
                                    <b>Tipo de Atividade</b>
                                </Row>
                                <Row style={{ alignItems: "center" }}>
                                    <LabelAndCheckbox
                                        readOnly={props.aguardando}
                                        gridDisplay="flex"
                                        gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                        gridAlignItems="end"
                                        style={{ marginLeft: 12 }}
                                        component={LabelAndCheckbox}
                                        label="Irrigante"
                                        cols="4 4 4 4"
                                        value={props.filtro.irrigante}
                                        onChange={() => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                irrigante: !props.filtro.irrigante,
                                            });
                                        }}
                                    />
                                    <LabelAndCheckbox
                                        readOnly={props.aguardando}
                                        gridDisplay="flex"
                                        gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                        gridAlignItems="end"
                                        style={{ marginLeft: 12 }}
                                        component={LabelAndCheckbox}
                                        label="Não-Irrigante"
                                        cols="8 8 8 8"
                                        value={props.filtro.naoIrrigante}
                                        onChange={() => {
                                            props.setFiltro({
                                                ...props.filtro,
                                                naoIrrigante: !props.filtro.naoIrrigante,
                                            });
                                        }}
                                    />
                                </Row>
                            </Grid>
                        )
                    )}
                    <Select
                        readOnly={props.aguardando || props.filtro.id_empenho}
                        options={props.listaUnidadeConsumidora}
                        label={
                            <LabelSelectUcIconeGestor
                                isMulti={true}
                                filtro={props.filtro}
                                listaUnidadeConsumidora={props.listaUnidadeConsumidora}
                                setExibirModal={(ucFiltro) =>
                                    props.setState({
                                        ...props.filtroState,
                                        exibirModalGestorConcessionaria: true,
                                        itemSelecionado: ucFiltro,
                                    })
                                }
                            />
                        }
                        cols={props.usuarioLogadoAcessoCliente ? "12 12 9 9" : "12 12 5 5"}
                        placeholder="Selecione as UCs"
                        isMulti={true}
                        value={props.filtro.unidades_consumidoras}
                        onChange={(ucsSelecionadas) => {
                            props.setFiltro({
                                ...props.filtro,
                                unidades_consumidoras: [...ucsSelecionadas],
                            });
                        }}
                    />
                    {props.usuarioLogadoAcessoCliente ? (
                        <Select
                            readOnly={props.aguardando}
                            name="id_concessionaria"
                            options={props.listaConcessionaria}
                            label="Concessionária"
                            cols="12 12 3 3"
                            placeholder="Selecione a concessionaria"
                            value={props.filtro.id_concessionaria}
                            onChange={(id_concessionaria) => {
                                props.setFiltro({
                                    ...props.filtro,
                                    id_concessionaria,
                                });
                            }}
                        />
                    ) : null}
                    {!props.usuarioLogadoAcessoCliente && (
                        <>
                            <Select
                                readOnly={props.aguardando}
                                name="id_concessionaria"
                                options={props.listaConcessionaria}
                                label="Concessionária"
                                cols="12 12 2 2"
                                placeholder="Selecione a concessionaria"
                                value={props.filtro.id_concessionaria}
                                onChange={(id_concessionaria) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_concessionaria,
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                name="id_grupo_faturamento"
                                options={props.listaGrupoFaturamento}
                                label="Tipo de Faturamento"
                                cols="12 12 2 2"
                                placeholder="Selecione o tipo de faturamento"
                                value={props.filtro.id_grupo_faturamento}
                                onChange={(id_grupo_faturamento) => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_grupo_faturamento,
                                    });
                                }}
                            />
                            <Select
                                readOnly={props.aguardando}
                                options={[
                                    { id: 1, valor: "Todas" },
                                    { id: 2, valor: "Download Realizado" },
                                    { id: 3, valor: "Download Pendente" },
                                ]}
                                label="Situação do Download"
                                cols="12 12 3 3"
                                placeholder="Selecione a situação do download"
                                value={props.filtroState.situacaoDownload}
                                isClearable={false}
                                isSearchable={false}
                                onChange={(value) => {
                                    props.setState({
                                        ...props.filtroState,
                                        situacaoDownload: value,
                                    });
                                }}
                            />
                        </>
                    )}
                </Row>
                <Row style={{ padding: 7 }}>
                    <Grid cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                        <Button
                            title="Filtros"
                            disabled={props.aguardando}
                            icon="fas fa-filter"
                            text="Filtros"
                            type={"light"}
                            solid={true}
                            forceBoxShadow={true}
                            event={() => setModalFiltrosAberto(true)}
                        />
                    </Grid>
                    {(props.buttons || []).map((botao, i) => (
                        <Grid key={i} cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                            {botao}
                        </Grid>
                    ))}
                </Row>
            </ContentCardHeader>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        listaMeses: state.fatura.listaMeses,
        listaCliente: state.fatura.listaCliente,
        listaConcessionaria: state.fatura.listaConcessionaria,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
        listaEmpenho: state.empenho.lista,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaFaturasAdm,
        },
        dispatch
    );
const FiltrosFaturasClienteEnergia = connect(mapStateToProps, mapDispatchToProps)(FiltrosFaturasClienteEnergiaComponent);
export { FiltrosFaturasClienteEnergia };
